<template>
    <b-form-invalid-feedback class="position-absolute" :state="state">
        {{ text }}
    </b-form-invalid-feedback>
</template>

<script>
    export default {
        name: "InvalidForm",
        props: {
            state: {
                type: Boolean,
                required: true
            },
            text: {
                type: String,
            },
        }
    }
</script>
